/* TWRD rotating announcement bar. Fades one message at a time. */
(function () {
  'use strict';

  var STORAGE_KEY = 'twrd-announcement-paused';

  /* Returnerer 'true', 'false' eller null. sessionStorage kaster i Safaris
     private mode og bag blokerede cookies, saa laesningen skal vaere pakket ind. */
  function readStored() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function readPaused() {
    return readStored() === 'true';
  }

  function writePaused(value) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
    } catch (error) {
      /* storage blocked, keep runtime state only */
    }
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (error) {
      return false;
    }
  }

  var INSTANCES = [];

  function TwrdAnnouncement(root) {
    this.root = root;
    this.items = Array.prototype.slice.call(root.querySelectorAll('.twrd-ann__item'));
    this.toggle = root.querySelector('.twrd-ann__toggle');
    this.index = 0;
    this.timer = null;
    this.interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    this.labelPause = root.getAttribute('data-label-pause') || 'Pause announcements';
    this.labelPlay = root.getAttribute('data-label-play') || 'Play announcements';

    if (this.items.length === 0) return;

    this.show(0);

    var stored = readStored();
    var paused = stored === null ? prefersReducedMotion() : stored === 'true';

    this.setPaused(paused, false);

    if (this.toggle) {
      this.toggle.addEventListener('click', this.onToggle.bind(this));
    }

    this.visibilityHandler = this.onVisibility.bind(this);
    document.addEventListener('visibilitychange', this.visibilityHandler);
    INSTANCES.push(this);
  }

  /* Section-reload i temaeditoren efterlader ellers det gamle interval og den
     gamle visibilitychange-lytter, som saa skriver i en node der er smidt ud. */
  TwrdAnnouncement.prototype.destroy = function () {
    this.stop();
    if (this.visibilityHandler) {
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      this.visibilityHandler = null;
    }
    var at = INSTANCES.indexOf(this);
    if (at !== -1) INSTANCES.splice(at, 1);
  };

  TwrdAnnouncement.prototype.show = function (index) {
    for (var i = 0; i < this.items.length; i++) {
      var isActive = i === index;
      this.items[i].classList.toggle('is-active', isActive);
      this.items[i].setAttribute('aria-hidden', isActive ? 'false' : 'true');
    }
    this.index = index;
  };

  TwrdAnnouncement.prototype.next = function () {
    if (this.items.length < 2) return;
    this.show((this.index + 1) % this.items.length);
  };

  TwrdAnnouncement.prototype.start = function () {
    this.stop();
    if (this.items.length < 2) return;
    this.timer = window.setInterval(this.next.bind(this), this.interval);
  };

  TwrdAnnouncement.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  TwrdAnnouncement.prototype.setPaused = function (paused, persist) {
    this.paused = paused;
    this.root.setAttribute('data-paused', paused ? 'true' : 'false');

    if (this.toggle) {
      this.toggle.setAttribute('aria-label', paused ? this.labelPlay : this.labelPause);
      this.toggle.setAttribute('title', paused ? this.labelPlay : this.labelPause);
      this.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
    }

    if (paused) {
      this.stop();
    } else {
      this.start();
    }

    if (persist) writePaused(paused);
  };

  TwrdAnnouncement.prototype.onToggle = function (event) {
    event.preventDefault();
    this.setPaused(!this.paused, true);
  };

  TwrdAnnouncement.prototype.onVisibility = function () {
    if (document.hidden) {
      this.stop();
    } else if (!this.paused) {
      this.start();
    }
  };

  /* The "sign up" message points at /#signup. The homepage newsletter block
     carries that id in templates/index.json; this is the runtime fallback for
     themes where the template still holds the old markup. */
  function ensureSignupAnchor() {
    if (document.getElementById('signup')) return;

    var section = document.querySelector('[id$="__tw_newsletter"]');
    if (!section) return;

    var anchor = document.createElement('span');
    anchor.id = 'signup';
    anchor.style.display = 'block';
    anchor.style.scrollMarginTop = '130px';
    section.parentNode.insertBefore(anchor, section);

    if (window.location.hash === '#signup') {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function init() {
    try {
      ensureSignupAnchor();
    } catch (error) {
      /* the anchor is a convenience, never block the bar on it */
    }

    var roots = document.querySelectorAll('.twrd-ann[data-twrd-announcement]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].dataset.twrdReady === 'true') continue;
      roots[i].dataset.twrdReady = 'true';
      new TwrdAnnouncement(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    for (var i = INSTANCES.length - 1; i >= 0; i--) {
      var root = INSTANCES[i].root;
      if (!document.body.contains(root) || (event.target && event.target.contains(root))) {
        INSTANCES[i].destroy();
      }
    }
  });

  window.TwrdAnnouncementInit = init;
  window.__twrdReadPaused = readPaused;
})();
